var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarninginline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.271,
    height: 16.271,
    viewBox: "0 0 16.271 16.271",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffed6a;}.b{fill:none;}.c{fill:#382d10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-744.514 -531.278)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M752.65,531.278a8.136,8.136,0,1,1-8.136,8.136A8.136,8.136,0,0,1,752.65,531.278Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(744.514 531.278)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M752.65,531.278a8.136,8.136,0,1,1-8.136,8.136A8.136,8.136,0,0,1,752.65,531.278Z",
    transform: "translate(-744.514 -531.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M752.65,532.295a7.119,7.119,0,1,0,5.034,2.085,7.072,7.072,0,0,0-5.034-2.085m0-1.017a8.136,8.136,0,1,1-8.136,8.136A8.136,8.136,0,0,1,752.65,531.278Z",
    transform: "translate(-744.514 -531.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M759.747,547.585a1.3,1.3,0,0,1-1.293-1.315v0a1.3,1.3,0,0,1,1.29-1.319h0a1.3,1.3,0,0,1,1.293,1.315v.054A1.3,1.3,0,0,1,759.747,547.585Zm0-3.516a.874.874,0,0,1-.865-.879v-3.515a.865.865,0,1,1,1.729,0v3.516A.874.874,0,0,1,759.747,544.069Z",
    transform: "translate(-751.366 -534.974)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarninginline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.inline.74bae4c4725e4a9d591f7e3862a95740.svg";